

// portal
// const api_url = 'https://portal.snappmobiledevelopment.co.nz';
// const api_key = `API_KEY=e22e7629ff97ca3e5aaaa0dd2e6f1b88`;
// hastings girls high
// const api_url = 'https://hastingsgirlshigh.apps.school.nz';
// const api_key = `API_KEY=1c782d258c04f53643357309df45a438`;
// medbury
// const api_url = 'https://medbury.apps.school.nz';
// const api_key = `API_KEY=1fd7dfbff7973255be116dbad51baa98`;
// Kauri Park
// const api_url = 'https://kauriparkschool.apps.school.nz';
// const api_key = `API_KEY=0445745768064f90778aebf1d0386573`;
// Farmcove Intermediate
// const api_url = 'https://farmcoveintermediate.apps.school.nz';
// const api_key = `API_KEY=073073286bb162d2af9e8c733dd0c8ca`;
// Rolleston School
// const api_url = 'https://rollestonschool.apps.school.nz';
// const api_key = `API_KEY=a52d21b53ab67907d56d40bc4cc9aa47`;
// Rolleston School
// const api_url = 'https://victoriaave.snappmobiledevelopment.co.nz';
// const api_key = `API_KEY=f6276f4eebf037c5c7a29b7b170ccf93`;
// Rolleston School
// const api_url = 'https://whangareigirlshigh.snappmobiledevelopment.co.nz';
// const api_key = `API_KEY=e0dca8fcb487877bd7cafbc8667dab7b`;
// Rolleston School
// const api_url = 'https://maidstoneintermediate.snappmobiledevelopment.co.nz';
// const api_key = `API_KEY=a8153ed3bcd9ce29995a7f0e570f43c0`;
const api_url = '../.';
const api_key = `API_KEY=${window.api_key}`;
const version = '2.2.11';
const retrieveErrorMsg = 'Unable to retrieve any items, we\'ll try again in a moment';
const noItemsMsg = 'Currently no new items';

export class ApiService {

  getIcon() {
    return api_url + '/school/icon.png';
  }

  getContacts() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/contacts.php?' + api_key + '&version=' + version)
      .then(response => response.json())
      .then(json => {
        resolve(json.length === 0 ? [{noItems: noItemsMsg}] : json)
      })
      .catch(error => {
        resolve([{noItems: retrieveErrorMsg}])
      });
    });
  }

  getEvents() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/events.php?' + api_key + '&version=' + version + '&start=0&end=200')
      .then(response => response.json())
      .then(json => {
        const jsonData = json.items ? json.items : json;
        resolve(jsonData.length === 0
          ? {
              items: [{noItems: noItemsMsg}],
              filters:[]
            }
          : jsonData.filters 
            ? jsonData
            : {
              items: jsonData,
              filters:[]
            })
      })
      .catch(error => {
        resolve({
          items: [{noItems: retrieveErrorMsg}],
          filters:[]
        })
      });
    });
  }

  getLinks() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/links.php?' + api_key + '&version=' + version)
      .then(response => response.json())
      .then(json => {
        resolve(json.items.length === 0
          ? {
              items: [{noItems: noItemsMsg}],
              filters:[]
            }
          : json)
      })
      .catch(error => {
        resolve({
          items: [{noItems: retrieveErrorMsg}],
          filters:[]
        })
      });
    });
  }

  getMaps() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/maps.php?' + api_key)
      .then(response => response.json())
      .then(json => {
        resolve(json.length === 0 ? [{noItems: noItemsMsg}] : json)
      })
      .catch(error => {
        resolve([{noItems: retrieveErrorMsg}])
      });
    });
  }

  getNotices() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/notices.php?' + api_key + '&version=' + version)
      .then(response => response.json())
      .then(json => {
        resolve(json.items.length === 0
          ? {
              items: [{noItems: noItemsMsg}],
              filters:[]
            }
          : json)
      })
      .catch(error => {
        console.log(error);
        resolve({
          items: [{noItems: retrieveErrorMsg}],
          filters:[]
        })
      });
    });
  }

  getAlerts(categories) {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/alerts.php?' + api_key + categories + '&version=' + version)
      .then(response => response.json())
      .then(json => {
        resolve(json.length === 0 ? [{noItems: noItemsMsg}] : json)
      })
      .catch(error => {
        resolve([{noItems: retrieveErrorMsg}])
      });
    });
  }

  getSettings() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/settings.php?' + api_key + '&version=' + version)
      .then(response => response.json())
      .then(json => resolve(json))
      .catch(error => reject(error.message))
    });
  }

  getRss() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/modules/rss-reader.php?' + api_key)
      .then(response => response.json())
      .then(json => {
        resolve(json.length === 0 ? [{noItems: noItemsMsg}] : json)
      })
      .catch(error => {
        resolve([{noItems: retrieveErrorMsg}])
      });
    });
  }

  getLinksList() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/modules/links-list.php?' + api_key + '&version=' + version)
      .then(response => response.json())
      .then(json => {
        resolve(json.items.length === 0
          ? {
              items: [{noItems: noItemsMsg}],
              filters:[]
            }
          : json)
      })
      .catch(error => {
        resolve({
          items: [{noItems: retrieveErrorMsg}],
          filters:[]
        })
      });
    });
  }

  getTermDates() {
    return new Promise((resolve, reject) => {
      fetch(api_url + '/modules/term-dates.php?' + api_key)
      .then(response => response.json())
      .then(json => {
        let jsonData;
        try {
          jsonData = JSON.parse(json[0].html_content);
        } catch(e) {
          jsonData = { "en" : json[0].html_content}
        }
        resolve([jsonData])
      })
      .catch(error => reject(error.message))
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/ApiService.js